import { __decorate } from "tslib";
import { LitElement, html, customElement } from 'lit-element';
let DemoFooter = class DemoFooter extends LitElement {
    render() {
        return html `
      <cds-grid>
        <cds-grid-column>Type</cds-grid-column>
        <cds-grid-column>Description</cds-grid-column>
        <cds-grid-column>Amount</cds-grid-column>
        <cds-grid-column>Balance</cds-grid-column>

        <cds-grid-row>
          <cds-grid-cell>Deposit</cds-grid-cell>
          <cds-grid-cell>Item</cds-grid-cell>
          <cds-grid-cell>$1,000,000.00</cds-grid-cell>
          <cds-grid-cell>$1,000,000.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Credit</cds-grid-cell>
          <cds-grid-cell>Billing</cds-grid-cell>
          <cds-grid-cell>$250.00</cds-grid-cell>
          <cds-grid-cell>$523,750.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Debit</cds-grid-cell>
          <cds-grid-cell>Renewal</cds-grid-cell>
          <cds-grid-cell>$9.00</cds-grid-cell>
          <cds-grid-cell>$163,262.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Credit</cds-grid-cell>
          <cds-grid-cell>Subscription</cds-grid-cell>
          <cds-grid-cell>$53.00</cds-grid-cell>
          <cds-grid-cell>$347,423.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Deposit</cds-grid-cell>
          <cds-grid-cell>Subscription</cds-grid-cell>
          <cds-grid-cell>$1239.00</cds-grid-cell>
          <cds-grid-cell>$564,772.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Deposit</cds-grid-cell>
          <cds-grid-cell>Service Fee</cds-grid-cell>
          <cds-grid-cell>$49.00</cds-grid-cell>
          <cds-grid-cell>$977,527.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Debit</cds-grid-cell>
          <cds-grid-cell>Account Transfer</cds-grid-cell>
          <cds-grid-cell>$2300.00</cds-grid-cell>
          <cds-grid-cell>$423,236.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Credit</cds-grid-cell>
          <cds-grid-cell>Payment</cds-grid-cell>
          <cds-grid-cell>$9.00</cds-grid-cell>
          <cds-grid-cell>$199,282.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Debit</cds-grid-cell>
          <cds-grid-cell>Unknown</cds-grid-cell>
          <cds-grid-cell>$9.00</cds-grid-cell>
          <cds-grid-cell>$929,741.00</cds-grid-cell>
        </cds-grid-row>
        <cds-grid-row>
          <cds-grid-cell>Debit</cds-grid-cell>
          <cds-grid-cell>Provider</cds-grid-cell>
          <cds-grid-cell>$9203.00</cds-grid-cell>
          <cds-grid-cell>$239,120.00</cds-grid-cell>
        </cds-grid-row>
        <!-- <cds-grid-footer>
          Footer Content
        </cds-grid-footer> -->
      </cds-grid>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
DemoFooter = __decorate([
    customElement('demo-footer')
], DemoFooter);
export { DemoFooter };
//# sourceMappingURL=demo.footer.js.map